export const apiKey = '0477f220afab79418e9a6ce9edbe5817'
export const tmdbUrl = 'https://api.themoviedb.org/3'

// https://api.themoviedb.org/3/genre/movie/list?api_key=0477f220afab79418e9a6ce9edbe5817
// https://api.themoviedb.org/3/genre/movies/list?api_key=0477f220afab79418e9a6ce9edbe5817